const TRACKING_PARAMS = ['source', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

export function sanitizeUrl(url: string): string {
  if (!url) return url;
  try {
    const parsed = new URL(url);
    let changed = false;
    for (const param of TRACKING_PARAMS) {
      if (parsed.searchParams.has(param)) {
        parsed.searchParams.delete(param);
        changed = true;
      }
    }
    if (!changed) return url;
    const clean = parsed.toString();
    return clean.endsWith('?') ? clean.slice(0, -1) : clean;
  } catch {
    return url.replace(/[?&]source=openai/gi, '').replace(/[?&]source=openAI/g, '');
  }
}

export function sanitizeTextUrls(text: string): string {
  if (!text) return text;
  return text.replace(/https?:\/\/[^\s)\]>"']+/g, (match) => sanitizeUrl(match));
}
